import { bsc as viemBsc } from 'viem/chains';

import { getContrastColor } from '@infinex/ui-utils/color';

import { envOverrides } from '../../env';
import {
  DEFAULT_CHAIN_LIMITS,
  defaultEnvironments,
  defaultServices,
  defaultSwidge,
} from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const bsc = {
  displayName: 'BNB Chain',
  runtime: 'evm',
  viemChain: viemBsc,
  isSupported: true,
  isReleased: true,
  isMainnet: true,
  orderPriority: 6,

  decoration: {
    color: '#F0B90B',
    contrastColor: getContrastColor('#F0B90B'),
  },
  features: {
    wallet: {
      supported: true,
      eip7702: true,
      autoUpgradeSCA: true,
      defaultKind: 'EOA',
      import: true,
    },
    vault: {
      supported: true,
      ccqRecovery: true,
    },
  },
  connectivity: {
    rpc: {
      quicknode: {
        chainKey: 'bsc',
      },
    },
    blockExplorers: {
      primary: {
        base: 'https://bscscan.com',
        token: 'https://bscscan.com/token',
      },
    },
  },
  environments: defaultEnvironments(true),
  swidge: defaultSwidge({
    debridge: {
      chainKey: '56',
      providerContract: '0x43dE2d77BF8027e25dBD179B491e8d64f38398aA',
    },
    lifi: { chainKey: 'BSC' },
    stargate: { chainKey: 'bsc' },
    across: { chainKey: 'bnb-smart-chain' },
    xswap: { chainKey: '56' },
    okx: { chainKey: '56' },
    kyberswap: { chainKey: 'bsc' },
    houdini: { chainKey: 'BSC' },
  }),
  services: defaultServices({
    codex: {
      networkId: 56,
      nativeLiquidityAddress: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    },
    defiLlama: { chainKeys: ['bsc'] },
    trm: { chainKey: 'binance_smart_chain' },
    zerion: { chainKey: 'binance-smart-chain' },
    coingecko: {
      networkId: 'bsc',
      platformId: 'binance-smart-chain',
    },
    coingeckoDex: {
      networkId: 'bsc',
    },
    qnStreams: {
      networkKey: 'bnbchain-mainnet',
    },
    safe: { shortName: 'bnb' },
    alchemy: { chainSlug: 'bnb-mainnet' },
    pimlico: { chainSlug: 'binance' },
  }),
  limits: envOverrides(DEFAULT_CHAIN_LIMITS, {}),
} as const satisfies AllChainConfig<'evm', true>;
